var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.show
        ? _c("NotificationHistorySidebar", {
            attrs: { onModalClose: () => (this.show = false) },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-outline-info btn-rounded bg-white",
          on: { click: _vm.openBar },
        },
        [_c("i", { staticClass: "icon-fa icon-fa-history" })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }